module.exports = __webpack_public_path__ + "img/horizontal_3_2_pp2_9006.5e8b7a6b.png";